import React, { useEffect, useState } from "react";
import Navbar2 from "../components/navbar/Navbar2";
import AOS from "aos";
import "aos/dist/aos.css";
import LoadingPage from "./LoadingPage";
import JoinPrivateGame from "./CrazyHomePage/JoinPrivateGame";
import CreateGame from "./LatLatHomePage/CreateGame";
import WaitingGames from "./LatLatHomePage/WaitingGames";
import GameWinners from "./CrazyHomePage/GameWinners";
import { socket } from "../api"; // ✅ important
import Footer from "../components/navbar/Footer";

export default function LatLatGamePage() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    AOS.init({ duration: 500, easing: "ease-in-sine" });

    // Request rooms ONCE for entire page
    socket.emit("get-all-rooms");

    socket.on("all-rooms", () => {
      setLoading(false); // ✅ page unlocks only when backend responds
    });

    return () => {
      socket.off("all-rooms");
    };
  }, []);

  if (loading) {
    return <LoadingPage />; // ✅ covers ENTIRE page
  }

  return (
    <div className="min-h-screen bg-primary p-4 space-y-8 mt-14 text-white">
      <div className="fixed left-0 right-0 top-0 z-50">
        <Navbar2 />
      </div>

      <WaitingGames />
      <CreateGame />
      <JoinPrivateGame />
      <GameWinners />
      <Footer />
    </div>
  );
}
